'use client';

import React, { HTMLAttributes, useEffect } from 'react';

import MapPinIcon from '../Icons/MapPin';
import { useMap } from '@/hooks/useMapContext';

interface IMapPinButtonProps extends HTMLAttributes<HTMLDivElement> {
  guideItem: GuideItem;
}

export const MapPinButton: React.FC<IMapPinButtonProps> = ({
  guideItem,
  className,
}) => {
  const { showMarkerInfoWindow } = useMap();

  const navigateToMarker = () => {
    showMarkerInfoWindow({
      ...guideItem,
      surrounding: guideItem.surrounding
        ? {
            ...guideItem.surrounding,
            location: {
              latitude: guideItem?.surrounding?.location?.latitude || 0,
              longitude: guideItem?.surrounding?.location?.longitude || 0,
            },
          }
        : guideItem.surrounding,
    });
  };

  return (
    <button
      className={`overflow-hidden h-0 w-0 desktop:h-auto desktop:w-auto desktop:overflow-auto top-5 right-5 text-white ${className} absolute z-20`}
      onClick={() => navigateToMarker()}>
      <MapPinIcon className={`h-0 w-0 desktop:h-6 desktop:w-6`} />
    </button>
  );
};
